"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
function stopLifesizeConnectPresentation() {
    return { type: constants_1.remoting.actions.LIFESIZE_CONNECT_STOP };
}
exports.default = {
    stopLifesizeConnectPresentation: stopLifesizeConnectPresentation
};
